import { ImageComponent } from '../image/ImageComponent'

import styles from './ServicesLogo.module.scss'

export default class ServicesLogo extends ImageComponent {
  render() {
    return this.baseRender(styles.image)
  }
}
